/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Section_DescriptionInputs */

const en_directory_ads_section_description = /** @type {(inputs: Directory_Ads_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One featured banner slot on the homepage, sold by the week. Pick a free week, choose your listing — payment publishes your banner immediately.`)
};

const zh_directory_ads_section_description = /** @type {(inputs: Directory_Ads_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页特选横幅位按周出售。选一个空闲周、选择你的产品，付款后横幅立即上线。`)
};

/**
* | output |
* | --- |
* | "One featured banner slot on the homepage, sold by the week. Pick a free week, choose your listing — payment publishes your banner immediately." |
*
* @param {Directory_Ads_Section_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_section_description = /** @type {((inputs?: Directory_Ads_Section_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Section_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_section_description(inputs)
	return zh_directory_ads_section_description(inputs)
});
export { directory_ads_section_description as "directory.ads.section_description" }